import { I18n } from '@calendly/i18n'
import { Chip, ChipGroup } from '@calendly/ui/components/chip'

export const MEETINGS_RECAP_SCOPE = Object.freeze({
  ALL_RECAPS: 'ALL_RECAPS',
  MY_RECAPS: 'MY_RECAPS',
  SHARED_WITH_ME_ONLY: 'SHARED_WITH_ME_ONLY'
})

export const DEFAULT_MEETINGS_RECAP_SCOPE = MEETINGS_RECAP_SCOPE.MY_RECAPS

const formatCount = (n) => (
  typeof n === 'number' && !Number.isNaN(n)
    ? n.toLocaleString()
    : null
)

const ScopeTabLabel = ({ label, count }) => {
  const countText = formatCount(count)

  if (countText == null) {
    return label
  }

  return (
    <>
      {label}
      {' '}
      {countText}
    </>
  )
}

/**
 * @param {Object} props
 * @param {string} props.value One of MEETINGS_RECAP_SCOPE
 * @param {(scope: string) => void} props.onChange
 * @param {Partial<Record<string, number>>} [props.counts] Optional per-scope totals (e.g. from search); omit to hide counts.
 */
export const RecapScopeTabs = ({ value, onChange, counts }) => {
  const items = [
    {
      id: MEETINGS_RECAP_SCOPE.ALL_RECAPS,
      textValue: I18n.t('publisher.recaps.recap_scope_tabs.all_recaps'),
    },
    {
      id: MEETINGS_RECAP_SCOPE.MY_RECAPS,
      textValue: I18n.t('publisher.recaps.recap_scope_tabs.my_recaps'),
    },
    {
      id: MEETINGS_RECAP_SCOPE.SHARED_WITH_ME_ONLY,
      textValue: I18n.t('publisher.recaps.recap_scope_tabs.shared_with_me'),
    },
  ]

  const handleSelectionChange = (keys) => {
    const keySet = keys === 'all'
      ? new Set(items.map((item) => item.id))
      : keys
    const selectedScope = Array.from(keySet)[0]

    if (selectedScope != null) {
      onChange(String(selectedScope))
    }
  }

  return (
    <ChipGroup
      aria-label={I18n.t('publisher.recaps.recap_scope_tabs.aria_label')}
      dependencies={['selectable']}
      items={items}
      onSelectionChange={handleSelectionChange}
      selectedKeys={[value]}
      selectionBehavior="replace"
      selectionMode="single"
    >
      {(item) => (
        <Chip
          key={item.id}
          aria-label={item.textValue}
          id={item.id}
          size="small"
          variant="selectable"
        >
          <ScopeTabLabel label={item.textValue} count={counts?.[item.id]} />
        </Chip>
      )}
    </ChipGroup>
  )
}
